var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThreadIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "redirect-to-url-svgrepo-com",
    d: "M6.58,6.531a1.382,1.382,0,1,1,2.764,0v6.937a2.488,2.488,0,1,0,4.975,0V9.858l.9.915.782-.8L13.766,7.7,11.533,9.977l.782.8.9-.915v3.611a1.382,1.382,0,1,1-2.764,0V6.531a2.488,2.488,0,1,0-4.975,0V8.125H4V12.25H8.054V8.125H6.58ZM5.106,9.25v1.875H6.948V9.25Z",
    transform: "translate(16 -4) rotate(90)",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThreadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thread_icon.859698f630de9a3de73eab484f08cf30.svg";